/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useSelector, useDispatch } from "react-redux";
import CheckRequest from "../components/ListItems/CheckRequest";
import EditCheckRequest from "../components/Modals/EditCheckRequest";
import { FamilyHasAccess, CurrentUser, DateTime, UserItem, TransactionItem, TransactionAllocation, TransactionCheckRequestItem } from "../types";
import { useItems } from "../features/Fetch/Items";
import { Grid, IconButton } from "@mui/material";
import { PlusLg } from "react-bootstrap-icons";
import { ModalProps, setProps } from "../features/Slices/modalSlice";
import {  useNavigate } from "react-router-dom";
import { Features } from "../constants";
import ApproveCheckRequest from "../components/Modals/ApproveCheckRequest";

const CheckRequests = (props: any) => {
	const repo = useItems();
	const user: CurrentUser = useSelector((state: any) => state.userData.value);
	const users: UserItem[] = useSelector((state: any) => state.users.value);

	const dispatch = useDispatch();
	const modal: ModalProps = useSelector((state: any) => state.modal.value);

	const navigate = useNavigate();

	const budgetTree = repo.GetBudgetTree();
	const checkRequests = repo.SortedCheckRequests()?.filter(c => c.isMine);
	const finalizedRequests = repo.SortedCheckRequests()?.filter(c => c.checkRequest!.approvalState === 2);

	if (!FamilyHasAccess(user, Features.CheckRequests)) {
		navigate('/');
		return <></>;
	}

	if (location.hash === '#new' && !modal.IsOpen) {
		OpenNewModal();
		navigate('/CheckRequests');
	}

	return (
		<>
			<Grid container rowSpacing={3} justifyContent="center" className="">
				<Grid item xs={9}>
					<h2 className="mt-2 text-app">Check Requests</h2>
				</Grid>
				<Grid item xs={2}>
					{!checkRequests && (< p ><em>Loading...</em></p>)}
					{checkRequests && (
						<IconButton
							className="text-app"
							aria-label='new menu'
							onClick={OpenNewModal}>
							<PlusLg />
						</IconButton>
					)}
				</Grid>
				{checkRequests != null && (
					<Grid container>
						{checkRequests.map(checkRequest => {
							return (
								<div className="w-100" key={`crdiv${checkRequest.checkRequest!.accountTransactionCheckRequestId}`}>
									<CheckRequest
										Item={checkRequest}
										OnClick={() => OpenModal(checkRequest.checkRequest!.accountTransactionCheckRequestId)}
										key={`checkRequest${checkRequest.checkRequest!.accountTransactionCheckRequestId}`} />
								</div>
							);
						})}
					</Grid>
				)}
				{user.isHoH && finalizedRequests != null && (
					<Grid container>
						{finalizedRequests.map(checkRequest => {
							return (
								<div className="w-100" key={`crdiv${checkRequest.checkRequest!.accountTransactionCheckRequestId}`}>
									<CheckRequest
										Item={checkRequest}
										OnClick={() => OpenPrintModal(checkRequest.checkRequest!.accountTransactionCheckRequestId)}
										key={`checkRequest${checkRequest.checkRequest!.accountTransactionCheckRequestId}`} />
								</div>
							);
						})}
					</Grid>
				)}
			</Grid>
		</>
	);

	function HideModal() {
		dispatch(setProps({ ...modal, IsOpen: false }));
	}

	async function SaveCheckRequest(item: TransactionItem) {
		HideModal();
		await repo.UpdateCheckRequestAsync(item, item.checkRequest!.accountTransactionCheckRequestId === 0, false);
		repo.GetCheckRequestsAsync();
	}

	function RejectCheckRequest(item: TransactionItem) {
		item.needsMyApproval = false;
		repo.ApproveCheckRequestAsync(item);
		HideModal();
		repo.GetCheckRequestsAsync();
	}

	function DeleteCheckRequest(item: TransactionItem) {
		repo.UpdateCheckRequestAsync(item, false, true);
		HideModal();
	}

	function OpenNewModal() {
        const checkRequest = {
			accountTransactionId: 0,
			merchant: "",
			receipt: undefined,
			receiptEmailId: undefined,
			hasReceipt: false,
			allocations: [{ amount: 0 } as TransactionAllocation],
			accountId: 0,
			transactionDate: new DateTime(),
			isMine: true,
			needsMyApproval: false,
			needsReimbursement: false,
			completedReimbursement: false,
			isIncome: false,
			created: "",
			lastUpdated: "",
			color: "",
			isMiles: false,
			isCheckRequest: true,
			checkRequest: {
				accountTransactionCheckRequestId: 0,
				amount: 0,
				reviewerId: 0,
				dateNeeded: new DateTime(),
				needsMailed: false,
				approvalState: 0,
				needsMyApproval: false,
				isMine: true,
				created: '',
				createdDate: new DateTime()
			} as TransactionCheckRequestItem
		};
		const newModal = {
			...modal,
			Body: <EditCheckRequest CheckRequest={checkRequest} Budgets={budgetTree} Users={users.filter(u => u.canApproveChecks)} OnSave={SaveCheckRequest} Close={HideModal} />,
			IsOpen: true,
			WasOpen: false
		};
		dispatch(setProps(newModal));
	}

	function OpenModal(idx: number) {
		const checkRequest = checkRequests!.find(t => t.checkRequest!.accountTransactionCheckRequestId === idx);
		if (checkRequest) {
			let newModal;
			if (checkRequest!.checkRequest!.approvalState === 2) {
				newModal = {
					...modal,
					Body: <ApproveCheckRequest Transaction={checkRequest} Budgets={budgetTree} ApproveValue={1} Close={HideModal} />,
					IsOpen: true,
					WasOpen: false
				};
			} else {
				newModal = {
					...modal,
					Body: <EditCheckRequest CheckRequest={checkRequest} Budgets={budgetTree} Users={users.filter(u => u.canApproveChecks)} OnSave={SaveCheckRequest} OnDelete={DeleteCheckRequest} Close={HideModal} />,
					IsOpen: true,
					WasOpen: false
				};
			}
			dispatch(setProps(newModal));
		}
	}

	function OpenPrintModal(idx: number) {
		const transaction = finalizedRequests!.find(t => t.checkRequest!.accountTransactionCheckRequestId === idx);
		if (transaction) {
			const newModal = {
				...modal,
				Body: <ApproveCheckRequest Transaction={transaction} Budgets={budgetTree} ApproveValue={1} Reject="Cancel Check and Send Back" Close={HideModal} OnSave={RejectCheckRequest} />,
				IsOpen: true,
				WasOpen: false
			};
			dispatch(setProps(newModal));
		}
	}
}

export default CheckRequests;